<template>
  <span>
    <!-- Dialog para gerenciamento de tipos de emolumento -->
    <Dialog class="test-box" header="Tipo Emolumento" :visible.sync="showTipoEmolumento" :modal="true"
      :closable="false">
      <div class="container">
        <div id="topo" class="row">
          <div class="col-md-12 mb-2">
            <label for="nome">Sigla: *</label>
            <span class="p-fluid">
              <InputText v-model="tipo.sigla" type="text" maxlength="2"/>
            </span>
          </div>
          <div class="col-md-12 mb-2">
            <label for="nome">Nome: *</label>
            <span class="p-fluid">
              <InputText v-model="tipo.nome" type="text" maxlength="200"/>
            </span>
          </div>
        </div>
      </div>

      <hr />

      <div class="container">
        <div class="row">
          <div>
            <Button @click="salvar()" href="#topo" type="button" label="Salvar"
              class="p-button-primary mr-2 p-button-success" icon="pi pi-check" :disabled="loading" />
          </div>

          <div>
            <Button @click="showTipoEmolumento = false" type="button" label="Fechar"
              class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" />
          </div>
        </div>
      </div>
      <hr />
      <div class="container scrolable-dialog selecao-tipo">
        <div class="row">
          <!-- Tabela que lista os tipos de emolumento cadastrados -->
          <DataTable :value="tiposEmolumento" :paginator="true" :rows="5" style="min-width: 100%">
            <Column headerStyle="width: 10%" field="sigla" header="Sigla"></Column>
            <Column  field="nome" header="Nome"></Column>
            <!-- Coluna com botões de ação para ativar/inativar -->
            <Column headerStyle="width: 8em" bodyStyle="text-align: center">
              <template #body="objeto">
                <Button type="button" v-if="!objeto.data.dataVigenciaFinal" class="p-button-danger" icon="pi pi-times" title="Inativar"
                  @click="inativar(objeto.data.id)"></Button>
                <Button type="button" v-if="objeto.data.dataVigenciaFinal" icon="pi pi-check" title="Ativar"
                  @click="ativar(objeto.data.id)"></Button>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </Dialog>
  </span>
</template>

<script>
// Importação dos serviços e modelos necessários
import CartorioService from "@/services/nfse/cartorio.service";
import TipoEmolumento from "@/models/nfse/TipoEmolumento";

export default {
  name: "TipoEmolumento",

  // Evento criado que é disparado quando um novo tipo é solicitado 
  created() {
    this.$root.$on("emolumento:novoTipo", idCliente => {
      this.idCliente = idCliente;
      this.tipo = new TipoEmolumento();
      CartorioService.findAllTiposEmolumentoByFiltro(
        idCliente,
        ""
      ).then(
        tipos => {
          this.tiposEmolumento = tipos.data;
          this.exibirDialogTipoEmolumento();
        },
        error => {
          let errorMessage = "Houve um problema carregar Tipos de Emolumentos!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );


    });
  },

  // Dados do componente
  data() {
    return {
      idCliente: null, // ID do cliente atual
      showTipoEmolumento: false, // Controle de exibição do dialog
      tipo: new TipoEmolumento(), // Objeto do tipo sendo editado
      tiposEmolumento: [] // Lista de tipos cadastrados
    };
  },

  methods: {
    // Carrega a lista de tipos de emolumento do servidor
    carregarLista(){
      CartorioService.findAllTiposEmolumentoByFiltro(
        this.idCliente,
        ""
      ).then(
        tipos => {
          this.tiposEmolumento = tipos.data;
        },
        error => {
          let errorMessage = "Houve um problema carregar Tipos de Emolumentos!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
    },

    // Exibe o dialog para edição de tipo de emolumento
    exibirDialogTipoEmolumento() {
      this.showTipoEmolumento = true;
    },

    // Salva um novo tipo de emolumento ou atualiza um existente
    salvar() {
      if (this.tipo.nome && this.tipo.sigla) {
        this.$parent.processando(true);
        this.tipo.idCliente = this.idCliente;
        CartorioService.saveTipoEmolumento(this.tipo)
          .then(
            data => {
              console.log(data);
              this.carregarLista();
              this.$root.$emit("alert:success", "Tipo Emolumento salvo com sucesso!");
            },
            error => {
              this.$root.$emit(
                "alert:warn",
                error.response
              );

            }
          )
          .then(() => {
            this.$parent.processando(false);
          });
      } else {
        this.$root.$emit(
          "alert:warn",
          "É necessário informar o nome do tipo de emolumento e a sigla!"
        );
      }
    },

    // Ativa um tipo de emolumento inativo
    ativar(id) {

      CartorioService.ativarTipoEmolumento(id)
        .then(
          data => {
            console.log(data);
            this.carregarLista();
            this.$root.$emit("alert:success", "Tipo Emolumento ativado com sucesso!");
          },
          error => {
            this.$root.$emit(
              "alert:warn",
              error.response
            );

          }
        )
        .then(() => {
          console.log('a');
        });
    },

    // Inativa um tipo de emolumento ativo 
    inativar(id) {

      CartorioService.inativarTipoEmolumento(id)
        .then(
          data => {
            console.log(data);
            this.carregarLista();
            this.$root.$emit("alert:success", "Tipo Emolumento inativado com sucesso!");
          },
          error => {
            this.$root.$emit(
              "alert:warn",
              error.response
            );

          }
        )
        .then(() => {
          console.log('a');
        });
    }
  },

  computed: {
    loading() {
      return this.$parent.loading;
    }
  }
};
</script>

<style scoped>
textarea {
  width: 100%;
  border-radius: 12px;
}

.scrolable-dialog {
  padding-right: 25px;
  width: 90vw;
  max-height: 65vh;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>